import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { TBookData } from '@shared/jp/models';
import { getHeroName } from '@shared/jp/utils';

@Component({
  selector: 'app-book-button',
  templateUrl: './book-button.component.html',
  styleUrls: ['./book-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookButtonComponent {
  @Input() booksList!: TBookData[];

  public getHeroName = getHeroName;

  // constructor() {}
}
